var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6719 3.4563L10.5442 0.328118C10.4402 0.224094 10.3167 0.141575 10.1808 0.0852761C10.0449 0.028977 9.89927 0 9.75217 0C9.60507 0 9.4594 0.028977 9.3235 0.0852761C9.1876 0.141575 9.06412 0.224094 8.96011 0.328118L0.328309 8.96019C0.223854 9.06381 0.141039 9.18716 0.084678 9.32307C0.0283173 9.45897 -0.000464413 9.60473 5.66653e-06 9.75186V12.88C5.66653e-06 13.1771 0.118007 13.4619 0.32805 13.672C0.538093 13.882 0.822973 14 1.12002 14H4.24835C4.39549 14.0005 4.54125 13.9717 4.67717 13.9153C4.81308 13.859 4.93644 13.7762 5.04006 13.6717L13.6719 5.04034C13.7759 4.93634 13.8584 4.81286 13.9147 4.67697C13.971 4.54107 14 4.39541 14 4.24832C14 4.10122 13.971 3.95557 13.9147 3.81967C13.8584 3.68377 13.7759 3.5603 13.6719 3.4563ZM4.24835 12.88H1.12002V9.75186L7.28009 3.59209L10.4084 6.72027L4.24835 12.88ZM11.2001 5.9279L8.0718 2.80042L9.75182 1.12049L12.8802 4.24797L11.2001 5.9279Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit_profile.4511c7cd2c1d58412f9f495fca1b871f.svg";
export { ForwardRef as ReactComponent };